<template>
  <div>
    <input
      :type="type"
      class="form-control"
      :class="{ 'is-invalid': hasErrors, [colClass]: true }"
      :name="attribute.name"
      :id="attribute.name"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :disabled="disabled"
      :placeholder="placeholder"
    />
    <div
      v-if="attribute.errors !== null"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    colClass() {
      const col = this.attribute.col !== undefined ? this.attribute.col : 12;
      return `col-${col}`;
    },
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    type() {
      return this.attribute.type;
    },
    placeholder() {
      return this.attribute.placeholder ? this.attribute.placeholder : "";
    }
  }
}
</script>
